import filterpaper from '../../../img/filterpaper.png';
import './Projectrightimage.css';

const ProjectImage = () => {
  return (
    <img 
      src={filterpaper} 
      alt="Filter Paper photo editing application" 
      className="photossss reveal fade-right" 
    />
  );
};

export default ProjectImage;
